import { render, staticRenderFns } from "./medicalInstitution.vue?vue&type=template&id=37d3eaf7&scoped=true&"
import script from "./medicalInstitution.vue?vue&type=script&lang=js&"
export * from "./medicalInstitution.vue?vue&type=script&lang=js&"
import style0 from "./medicalInstitution.vue?vue&type=style&index=0&id=37d3eaf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d3eaf7",
  null
  
)

export default component.exports